import { useRouterState } from '@tanstack/react-router'

/** Whether the page on screen is a flow (`staticData: { chrome: 'flow' }`): it hides the app's
 *  navigation and has its own way on and out in a bar at the foot. */
export function useIsFlow(): boolean {
  return useRouterState({
    select: (status) => status.matches.at(-1)?.staticData.chrome === 'flow',
  })
}
